// @ts-nocheck
import { RaiseSelect } from "../raise-components"
import React from "react"

import { Select } from "@atos6/ui"
import { useStore } from "../containers"

export function InputBankStateful() {
  const { bankId, banks, setState } = useStore()

  return (
    <RaiseSelect
      size="large"
      value={bankId}
      onChange={bankId => setState({ bankId })}
      showSearch
      optionFilterProp="children"
      filterOption={(input, option) => {
        return (
          option.children
            .toString()
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
        )
      }}>
      {banks.map(([id, code, label]) => (
        <Select.Option key={id} value={id}>
          {code} - {label}
        </Select.Option>
      ))}
    </RaiseSelect>
  )
}
